import * as cn from "classnames";
import * as React from "react";
import * as styles from "./styles.css";
import GridColumn from "backpack-ui/dist/components/gridColumn";
var ArticleHeaderInfo = function (_a) {
    var children = _a.children;
    return (React.createElement(GridColumn, { className: cn("ArticleHeaderInfo", styles.articleHeaderInfo), sm: 12, md: 3, lg: 2, fluid: true }, children));
};
export default ArticleHeaderInfo;



//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/components/articleHeaderInfo/index.tsx
// module id = VyZ2
// module chunks = 3